import createErrorMessage from "@shared/factories/src/errorMessage.factory"
import * as leadsApi from "@hub/leads/src/api/leads.api"

const showToastError = (error, message) => {
  window.$vue.$toast({
    type: "error",
    title:
      createErrorMessage(error).getMessage() || message
  })
}

const showToastSuccess = (message) => {
  window.$vue.$toast({
    type: "success",
    title: message
  })
}

export async function list(params) {
  try {
    const data = await leadsApi.list(params)
    return data
  } catch (error) {
    console.error(error)
    showToastError(error, "Falha ao obter listagem.")
    throw error
  }
}

export async function getIndicators(params) {
  try {
    const data = await leadsApi.getIndicators(params)
    return data
  } catch (error) {
    console.error(error)
    showToastError(error, "Falha ao obter indicadores.")
    throw error
  }
}

export async function get(uuid) {
  try {
    const { data } = await leadsApi.get(uuid)
    return data
  } catch (error) {
    console.error(error)
    showToastError(error, "Falha ao obter lead.")
    throw error
  }
}

export async function fetchStatesByProvider() {
  try {
    const { data } = await leadsApi.fetchStatesByProvider()
    return data
  } catch (error) {
    console.error(error)
    showToastError(error, "Falha ao obter estados disponíveis.")
    throw error
  }
}

export async function listCities(payload) {
  try {
    const { data } = await leadsApi.listCities(payload)
    return data
  } catch (error) {
    console.error(error)
    showToastError(error, "Falha ao obter cidades disponíveis.")
    throw error
  }
}

export async function getTags() {
  try {
    const { data } = await leadsApi.getTags()
    return data
  } catch (error) {
    console.error(error)
    showToastError(error, "Falha ao obter tags.")
    throw error
  }
}

export async function create(payload) {
  try {
    const { data } = await leadsApi.create(payload)
    showToastSuccess("Lead criada com sucesso!")
    return data
  } catch (error) {
    console.error(error)
    showToastError(error, "Falha ao criar lead.")
    throw error
  }
}

export async function update(uuid, payload) {
  try {
    const { data } = await leadsApi.update(uuid, payload)
    showToastSuccess("Lead atualizada com sucesso!")
    return data
  } catch (error) {
    console.error(error)
    showToastError(error, "Falha ao atualizar lead.")
    throw error
  }
}

export const fetchAddressComplements = async params => {
  try {
    const data = await leadsApi.fetchAddressComplements(params)
    return data
  } catch (error) {
    console.error(error)
    showToastError(error, "Falha ao buscar os complementos de endereços.")
    throw error
  }
}

export const fetchAddress = async postcode => {
  try {
    const { data } = await leadsApi.fetchAddress(postcode)
    return data
  } catch (error) {
    console.error(error)
    showToastError(error, "Falha ao buscar endereço.")
    throw error
  }
}

export const listImportationTypes = async () => {
  try {
    const { data } = await leadsApi.listImportationTypes()
    return data
  } catch (error) {
    console.error(error)
    showToastError(error, "Falha ao buscar tipos de importação.")
    throw error
  }
}

export const getTemplateModel = async importationTypeUuid => {
  try {
    const response = await leadsApi.getTemplateModel(importationTypeUuid)
    return response
  } catch (error) {
    console.error(error)
    showToastError(error, "Falha ao buscar modelo de importação.")
    throw error
  }
}

export const importLeads = async (params) => {
  try {
    const { data } = await leadsApi.importLeads(params)
    return data
  } catch (error) {
    console.error(error)
    showToastError(error, "Falha ao importar leads.")
    throw error
  }
}

export const verifyImportationStatus = async (params) => {
  try {
    const { data } = await leadsApi.verifyImportationStatus(params)
    return data
  } catch (error) {
    console.error(error)
    showToastError(error, "Falha ao verificar status da importação.")
    throw error
  }
}

export const getLeadHistory = async (uuid) => {
  try {
    const { data } = await leadsApi.getLeadHistory(uuid)
    return data
  } catch (error) {
    console.error(error)
    this.showToastError(error, "Falha ao buscar histórico do lead.")
    throw error
  }
}
